// The owner supplied AED 400,000–1,000,000 for a 2,000 sq ft villa renovation.
// Keep that broad reference rather than inventing finish-tier or other-service rates.
export const SQFT_PER_SQM = 10.76391041671;
export const VILLA_RENOVATION_RATE = Object.freeze({ low: 200, high: 500 });
const TYPES = new Set(['villa', 'apartment', 'office', 'holiday', 'other']);
const SCOPES = new Set(['full-fitout', 'renovation', 'kitchen', 'joinery', 'furnishing', 'curtains']);
const FINISHES = new Set(['essential', 'premium', 'luxury']);
const aed = (value) => Math.round(value).toLocaleString('en-AE');
export const formatBudget = ({ low, high }) => `AED ${aed(low)} – ${aed(high)}`;
export function areaInSqft(size, unit) {
  const n = Number(size);
  if (!Number.isFinite(n) || n <= 0 || !['sqft', 'sqm'].includes(unit)) return null;
  return unit === 'sqm' ? n * SQFT_PER_SQM : n;
}
export function convertArea(size, from, to) {
  const sqft = areaInSqft(size, from);
  if (sqft === null || !['sqft', 'sqm'].includes(to)) return '';
  return String(Math.round((to === 'sqm' ? sqft / SQFT_PER_SQM : sqft) * 100) / 100);
}
export function calculateBudget(form) {
  const sqft = areaInSqft(form.size, form.unit);
  const scope = [...new Set(form.scope || [])];
  const assessment = (reason, extra = {}) => ({ status: 'assessment', label: 'Site assessment required', range: null, ...extra, reason });
  if (sqft === null || !TYPES.has(form.projectType) || !FINISHES.has(form.finish) || !scope.length || scope.some(s => !SCOPES.has(s))) {
    return assessment('Complete the project details to prepare a planning budget.');
  }
  const fullRenovation = scope.includes('renovation');
  if (form.projectType !== 'villa' || !fullRenovation || scope.includes('full-fitout')) {
    return assessment('A reliable total needs a review of the property, quantities and specification. We will prepare an itemised estimate tailored to the work you need.');
  }
  if (sqft < 500 || sqft > 20000) return assessment('Please arrange a site assessment for this property size so the scope and measurements can be checked.');
  const range = {
    low: Math.round(sqft * VILLA_RENOVATION_RATE.low / 1000) * 1000,
    high: Math.round(sqft * VILLA_RENOVATION_RATE.high / 1000) * 1000,
  };
  const details = {
    range,
    basis: `${Math.round(sqft).toLocaleString('en-AE')} sq. ft. of internal built-up area × AED 200–500 per sq. ft.`,
    reason: 'A broad full-villa renovation allowance across finish levels. Your chosen materials, the existing property condition and final requirements determine the detailed estimate.',
  };
  if (scope.some(s => ['furnishing', 'curtains'].includes(s))) {
    return assessment('Your selected furnishing or curtain work needs quantities and specifications. The renovation reference below is not the total for all selected work.', details);
  }
  return { status: 'range', label: formatBudget(range), ...details };
}
